import axiosApi from "../axiosInstance";

const getDesignationList = async () => {
    try {
        let request = {};
        const response = await axiosApi.post(`/Designation/getDesignationList`, request);
        return response?.data;
    } catch (error) {
        console.log("Error getDesignationList===>:", error);
    }
};

const addDesignation = async (body) => {
    try {
        const response = await axiosApi.post(`Designation/CreateDesignation`, body);
        return response?.data;
    } catch (error) {
        console.log("Error addDesignation ===>", error);
    }
};

export const DesignationService = {
    getDesignationList,
    addDesignation
}